import moment from "moment";
import { PartOrder, PartOrderLang, PartOrderType } from "./part_order";

export interface PartOrderForm {
    id?: string;
    order_num: string;
    phone_no: string;
    sell_date: moment.Moment;
    last_call_date?: moment.Moment;
    date_received?: moment.Moment;
    confirmed: boolean;
    confirmed_at_date?: moment.Moment;
    type: PartOrderType;
    lang: PartOrderLang;
    call_try_interval_hours: number;
    part_lifetime_months?: number;
}

export const defaultPartOrderForm = (): PartOrderForm => {
    return {
        order_num: "",
        phone_no: "",
        sell_date: moment(),
        last_call_date: undefined,
        date_received: undefined,
        confirmed: false,
        confirmed_at_date: undefined,
        type: "P",
        lang: "fr",
        call_try_interval_hours: 3,
        part_lifetime_months: undefined,
    };
};

export const partOrderToForm = (partOrder: PartOrder): PartOrderForm => {
    return {
        ...partOrder,
    };
};

export const partOrderFormToBody = (partOrder: PartOrderForm): object => {
    return {
        ...partOrder,
    };
};
